/* Shared export helpers for the Insights reports. The report builds the header + row arrays
 * (owning its own columns); these utils own the file plumbing. CSV is always available; Excel
 * is a thin wrapper over the already-bundled `xlsx` (used by Manufacturing Insights). */

function csvCell(v) {
  if (v == null) return "";
  const s = String(v);
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

/* headers: string[]; rows: (string|number|null)[][]. Writes a UTF-8-BOM, CRLF, quoted CSV so
 * Excel opens it cleanly. */
export function downloadCsv(filename, headers, rows) {
  const lines = [headers.map(csvCell).join(",")];
  (rows || []).forEach((r) => lines.push(r.map(csvCell).join(",")));
  const blob = new Blob(["﻿" + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
  triggerDownload(blob, filename);
}

/* sheets: [{ name, headers, rows }]. Multi-sheet workbook. Lazy-imports xlsx so reports that
 * only use CSV don't pull it into their initial parse. */
export async function downloadXlsx(filename, sheets) {
  const XLSX = await import("xlsx");
  const wb = XLSX.utils.book_new();
  (sheets || []).forEach((s, i) => {
    const aoa = [s.headers || [], ...(s.rows || [])];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const name = (s.name || `Sheet${i + 1}`).slice(0, 31).replace(/[\\/?*[\]:]/g, " ");
    XLSX.utils.book_append_sheet(wb, ws, name);
  });
  XLSX.writeFile(wb, filename);
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
